import React, { useState } from 'react';
import legacyLogo from '../../Photos/logo2.png';

export default function Logo({ variant = 'dark' }) {
  const [logoError, setLogoError] = useState(false);

  return (
    <div className="flex items-center">
      {!logoError ? (
        <img
          src={legacyLogo}
          alt="Yo Me Controlo"
          className="h-[34px] md:h-[38px] w-auto object-contain"
          onError={() => setLogoError(true)}
        />
      ) : null}
    </div>
  );
}
